import React, { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import Logo from './Logo';
import '../pages/Landing.css';

const CONTACT_EMAIL = 'info@omniprac.com';

const Layout = () => {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const openQuote = (e) => { if (e) e.preventDefault(); setMenuOpen(false); setQuoteOpen(true); };
  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="op-page">
      {/* Nav */}
      <header className="op-nav">
        <div className="op-container op-nav-inner">
          <Link to="/" className="op-brand" aria-label="OmniPrac home" onClick={closeMenu}>
            <Logo />
          </Link>
          <nav className="op-nav-links">
            <Link to="/#features">Features</Link>
            <Link to="/pricing">Pricing</Link>
          </nav>
          <div className="op-nav-cta">
            <Link to="/login" className="op-btn op-btn-ghost">Client Login</Link>
            <button type="button" className="op-btn op-btn-primary" onClick={openQuote}>Request a Quote</button>
          </div>
          <button
            type="button"
            className={`op-nav-toggle ${menuOpen ? 'is-open' : ''}`}
            aria-label="Toggle menu"
            onClick={() => setMenuOpen((o) => !o)}
          >
            <span /><span /><span />
          </button>
        </div>
        <div className={`op-nav-mobile ${menuOpen ? 'is-open' : ''}`}>
          <Link to="/#features" onClick={closeMenu}>Features</Link>
          <Link to="/pricing" onClick={closeMenu}>Pricing</Link>
          <Link to="/login" className="op-btn op-btn-ghost op-btn-lg" onClick={closeMenu}>Client Login</Link>
          <button type="button" className="op-btn op-btn-primary op-btn-lg" onClick={openQuote}>Request a Quote</button>
        </div>
      </header>

      {/* Routed content */}
      <main id="main">
        <Outlet context={{ openQuote }} />
      </main>

      {/* Footer */}
      <footer className="op-footer">
        <div className="op-container">
          <div className="op-footer-top">
            <div className="op-footer-brand">
              <Logo />
              <p>
                Practice management built for anaesthetists — scheduling, ICD-10 coding, time-based
                billing, claims and collections in one platform.
              </p>
              <p style={{ marginTop: 8 }}>OmniPrac · South Africa</p>
            </div>
            <div>
              <h4>Product</h4>
              <ul>
                <li><Link to="/#features">Features</Link></li>
                <li><Link to="/pricing">Pricing</Link></li>
                <li><Link to="/login">Client Login</Link></li>
              </ul>
            </div>
            <div>
              <h4>Company</h4>
              <ul>
                <li><button type="button" className="op-footer-link" onClick={openQuote}>Request a Quote</button></li>
                <li><a href={`mailto:${CONTACT_EMAIL}`}>Contact</a></li>
                {/* TODO: link this once a POPIA privacy page exists. */}
                <li><span className="op-footer-note">Privacy (POPIA)</span></li>
              </ul>
            </div>
          </div>
          <div className="op-footer-bottom">
            <span>© {new Date().getFullYear()} OmniPrac. All rights reserved.</span>
            <span>Made in South Africa.</span>
          </div>
        </div>
      </footer>

      {/* Request a Quote modal */}
      {quoteOpen && (
        <div className="op-modal-overlay" onClick={() => setQuoteOpen(false)} role="dialog" aria-modal="true">
          <div className="op-modal" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="op-modal-close" onClick={() => setQuoteOpen(false)}>&times;</button>
            <h3>Request a Quote</h3>
            <p>
              OmniPrac is priced per practice, by quotation — based on your number of doctors,
              hospitals and the modules you need. Tell us about your practice and we’ll put a
              tailored proposal together.
            </p>
            <a
              className="op-btn op-btn-primary op-btn-lg"
              href={`mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent('OmniPrac — quotation request')}&body=${encodeURIComponent(
                'Hi OmniPrac team,\n\nPlease send me a quotation.\n\nPractice name:\nNumber of anaesthetists:\nHospitals worked at:\nBilling bureau (if any):\nBest contact number:\n\nThanks,'
              )}`}
            >
              Email {CONTACT_EMAIL}
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default Layout;
